import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["appearance", "className", "density", "field", "intent", "isDisabled", "isReadOnly", "onChange", "onFocus", "onBlur", "shape", "size"];
import * as React from 'react';
import cn from 'classnames';
import { EditorState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import { stateFromHTML } from 'draft-js-import-html';
import { Editor } from 'react-draft-wysiwyg';
import { intentClass, ControlSizeType, ControlAppearanceType, ControlShapeType, controlClasses, safeInvoke } from '../../../../library';
var inlineBasic = {
  options: ['history', 'inline', 'link', 'remove'],
  inline: {
    inDropdown: false,
    dropdownClassName: undefined,
    options: ['bold', 'italic', 'underline', 'strikethrough']
  }
};
var blockBasic = {
  options: ['history', 'blockType', 'list', 'inline', 'link', 'remove'],
  inline: {
    inDropdown: false,
    options: ['bold', 'italic', 'underline', 'strikethrough']
  },
  blockType: {
    inDropdown: true,
    options: ['Normal', 'H1', 'H2', 'H3', 'H4', 'H5', 'H6']
  },
  list: {
    inDropdown: true,
    options: ['unordered', 'ordered', 'indent', 'outdent']
  }
};
var Toolbars = {
  inlineBasic: inlineBasic,
  blockBasic: blockBasic
};
export var richTextClasses = {
  WRAPPER: 'rich-text',
  EDITOR: 'rich-text__editor',
  TOOLBAR: 'rich-text__toolbar'
};
export var RichText = function RichText(props) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    isFocused = _React$useState2[0],
    setIsFocused = _React$useState2[1];
  var handleEditorFocus = function handleEditorFocus(e) {
    setIsFocused(true);
    safeInvoke(props.onFocus, e);
  };
  var handleEditorBlur = function handleEditorBlur(e) {
    setIsFocused(false);
    safeInvoke(props.onBlur, e);
  };
  var appearance = props.appearance,
    className = props.className,
    density = props.density,
    field = props.field,
    intent = props.intent,
    isDisabled = props.isDisabled,
    isReadOnly = props.isReadOnly,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    shape = props.shape,
    size = props.size,
    editorProps = _objectWithoutProperties(props, _excluded);
  var classNames = cn(richTextClasses.WRAPPER, {
    '-disabled': isDisabled,
    '-readonly': isReadOnly,
    '-focus': isFocused && !isDisabled
  }, controlClasses({
    size: size,
    shape: shape,
    appearance: appearance,
    density: density
  }), intentClass(props.intent), props.className);
  return React.createElement(Editor, _extends({
    wrapperClassName: classNames,
    editorClassName: richTextClasses.EDITOR,
    toolbarClassName: richTextClasses.TOOLBAR,
    toolbarHidden: isDisabled || isReadOnly,
    readOnly: isDisabled || isReadOnly,
    onFocus: handleEditorFocus,
    onBlur: handleEditorBlur
  }, editorProps));
};
RichText.defaultProps = {
  shape: ControlShapeType.ROUNDED,
  size: ControlSizeType.MEDIUM,
  appearance: ControlAppearanceType.OUTLINE,
  toolbar: Toolbars.inlineBasic
};
RichText.displayName = 'RichTextArea';
RichText.Toolbars = Toolbars;
RichText.toHtml = function (contentState) {
  return stateToHTML(contentState);
};
RichText.htmlToState = function (html) {
  var contentState = stateFromHTML(html);
  return EditorState.createWithContent(contentState);
};
RichText.createEmptyState = function () {
  return EditorState.createEmpty();
};